import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorHandler } from '../../../../shared/ErrorHandler';
import { UserService } from '../../../../shared/user.service';
import swal from 'sweetalert2';
import { NgForm } from '@angular/forms';
@Component({
  selector: 'app-assistantform',
  templateUrl: './assistantform.component.html',
  styleUrls: ['./assistantform.component.css']
})
export class AssistantformComponent implements OnInit {
  title="Add Assistant";
  data : any = {};
  formInvalid : boolean = false;
  d : any = {};
  fileToUpload: File = null;

  AS_Id : number;
  mode : string;
  ActiveDetailsList: any=[];
  ActiveDetails: any=[];
  ActiveDetail: any=[];
  ActiveDetai: any=[];
  Active: any=[];
  ActiveDistrict: any=[];
  photoImageUrl: any;
  AS_Photo: string;
  Activespili: any=[];
  constructor(public service : UserService,private router: Router,private route: ActivatedRoute,  private errorHandler: ErrorHandler) { }

  ngOnInit() {
    this.GetAllPSADetailsForDropdown();
    this.GetAllPSADisgnation();
    this.GetAllQualification();
    this.GetState();
    this.GetsDistrict();
    this.Getsspi();
    this.route.params.subscribe(params => {      
      this.AS_Id = params['AS_Id'];  
      this.mode  =   params['mode'];   
        
        if(this.AS_Id > 0){
          this.getbyid(this.AS_Id)
        }    
        
    });

    if(this.mode=='view'){
      this.title = "View Assistance";
    }
    else if(this.mode=='edit'){
      this.title = "Edit Assistance";
    } 
   
  }
  SaveDistrict(Distict: NgForm){
        
    if(Distict.invalid)
    {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }     

    else{                                     
            this.data = this.service.PostFormone(Distict.value);    
            this.data.subscribe(
            (response) => {
              Distict.reset();
              Distict.resetForm();
              Distict.form.markAsPristine();
              Distict.form.markAsUntouched();        
              swal('Success!', 'Assistant Added Successfully .', 'success');
              this.router.navigate(['/menu/master']) ;   
              document.getElementById('loader-spinner').style.display = "none";           
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401) {
                this.errorHandler.HandlerError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            });    
    
    
    } 
  }
  cancel(){
    this.d.district_name="";
  }
  // GetDistrictById(district_id){
  //   document.getElementById('loader-spinner').style.display = "block";
  //       this.data = this.service.GetByIdDistrict(district_id);
  //       this.data.subscribe(
  //         (response: any) => {
  //           this.d = response;        
            
  //           // if (this.ap.AP_Date != null)
  //           //   this.ap.AP_Date = ((this.ap.AP_Date).split('T'))[0];
  //           // if (this.ap.AP_Date != null)
  //           //  this.ap.AP_Date = ((this.ap.AP_Date).split('T'))[0];    
                    
    
  //           document.getElementById('loader-spinner').style.display = "none";
  //         }, (error) => {
  //           document.getElementById('loader-spinner').style.display = "none";
  //         });
  // }
  UpdateDistrict(District: NgForm) {  
    this.data = this.service.updateAssistance(District.value,this.AS_Id);
   this.data.subscribe(
     (response) => {
      District.reset();
      District.resetForm();
      District.form.markAsPristine();
      District.form.markAsUntouched();           
                   
       swal('Success!', 'Assistances updated Successfully .', 'success');
       document.getElementById('loader-spinner').style.display = "none";   
       this.router.navigate(['/menu/master']) ;          
     }, (error) => {
       document.getElementById('loader-spinner').style.display = "none";
       if (error.status == 401) {
         this.errorHandler.HandlerError(error);
       }
       else if (error.status == 400) {
        swal('Warning!', error.error.Message, 'warning');
       }
     });   
}

Cancel(){
//this.router.navigate(['/menu/master']) ; 
this.d.district_name='';
this.d.district_id='';
}
GetAllPSADetailsForDropdown(){
  //alert('Inside');
  
  
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.GetallCategoryDropDownDetails();
    this.data.subscribe(
      (response: any) => {
        this.ActiveDetailsList = response;
      document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }
  GetAllPSADisgnation(){
    //alert('Inside');
    
    
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.service.GetallCategoryDropDown();
      this.data.subscribe(
        (response: any) => {
          this.ActiveDetails = response;
        document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
        });
    }
    GetAllQualification(){
      //alert('Inside');
      
      
        document.getElementById('loader-spinner').style.display = "block";
        this.data = this.service.GetallCategoryDrop();
        this.data.subscribe(
          (response: any) => {
            this.ActiveDetail = response;
          document.getElementById('loader-spinner').style.display = "none";
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
          });
      }
      GetState(){
        //alert('Inside');
        
        
          document.getElementById('loader-spinner').style.display = "block";
          this.data = this.service.GetallCategory();
          this.data.subscribe(
            (response: any) => {
              this.Active = response;
            document.getElementById('loader-spinner').style.display = "none";
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
            });
        }
        GetsDistrict(){
          //alert('Inside');
          
          
            document.getElementById('loader-spinner').style.display = "block";
            this.data = this.service.GetallCategorydrop();
            this.data.subscribe(
              (response: any) => {
                this.ActiveDistrict = response;
              document.getElementById('loader-spinner').style.display = "none";
              }, (error) => {
                document.getElementById('loader-spinner').style.display = "none";
              });
          }
          Getsspi(){
            //alert('Inside');
            
            
              document.getElementById('loader-spinner').style.display = "block";
              this.data = this.service.GetCategory();
              this.data.subscribe(
                (response: any) => {
                  this.Activespili = response;
                document.getElementById('loader-spinner').style.display = "none";
                }, (error) => {
                  document.getElementById('loader-spinner').style.display = "none";
                });
            }
          FileInputPhoto(file: FileList) {
    
            //let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
            let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|JPEG|JPG)$/;
            let s: any = file.item(0).size / 1024;
            let size: any = parseFloat(s).toFixed(2);
            let uploadedFilename = file.item(0).name;
            if (uploadedFilename.match(regex) && (size <= 5048)) {
              this.fileToUpload = file.item(0);
              var reader = new FileReader();
              reader.onload = (event: any) => {
                 this.photoImageUrl = event.target.result;
              }
              reader.readAsDataURL(this.fileToUpload);
              const data = new FormData();
              data.append("UploadedImage", file.item(0));
              let x = this.service.uploadImagesFile(data);
              x.subscribe(
                (response) => {
                  
        
                }, (error) => {
                  let i: any = document.getElementById('AS_Photo');
                  i.value = "";
                  if (error.status == 400) {
                     this.AS_Photo = "assets/images/image-default.png";
                    swal('Warning!', error.error.Message, 'warning');
                  }
                });
            }
            else {
              let i: any = document.getElementById('AS_Photo');
              i.value = "";
              if (!uploadedFilename.match(regex))
                swal('Warning!', "Please upload PDF and Image file with extension pdef or pdf and .jpeg,jpg or png", 'warning');
              else if (size > 2048)
                swal('Warning!', "Please upload image file less than 2mb", 'warning');
            }
          }
          
        
          getImagePDFUrl() {
            let imagename = null;
            try {
              imagename = document.getElementById('AS_Photo');
              return imagename.files[0].name;
            }
            catch (e) {
              return null;
            }
          }
          getbyid(AS_Id) {
            {
              
             // this.a.Image_path=this.photoImageUrl;
              document.getElementById('loader-spinner').style.display = "block";
              this.data = this.service.getbyassistence(AS_Id);
              this.data.subscribe(
                (response: any) => {
                this.d = response;
                this.photoImageUrl=this.d.AS_Photo;
                  if (this.d.AS_DOB != null)
                  this.d.AS_DOB = ((this.d.AS_DOB).split('T'))[0];
           document.getElementById('loader-spinner').style.display = "none";
                }, (error) => {
                  document.getElementById('loader-spinner').style.display = "none";
                });
            }
        
          }
        
}



// WEBPACK FOOTER //
// ./src/app/Pages/manage/assistant/assistantform/assistantform.component.ts